import { fork, take, put, call } from 'redux-saga/effects';

import * as FIREBASE from '../../Firebase';

import { FIREBASE_CALL } from './actions';

function* handleFirebase({ firebaseType, data, actionTypes }) {
  // const token = state && state.auth && state.auth.get('token');
  const [requestType, successType, errorType] = actionTypes;
  yield put({ type: requestType, payload: { firebaseType, data, actionTypes } });

  try {
    switch (firebaseType) {
      case FIREBASE.FIREBASE_TYPE.SIGNIN_EMAIL: {
        const { email, password } = data;
        const result = yield call(FIREBASE.signInWithEmail, email, password);
        yield put({ type: successType, payload: { firebaseType, result } });
        break;
      }
      case FIREBASE.FIREBASE_TYPE.SIGN_UP_EMAIL: {
        const { email, password } = data;
        const result = yield call(FIREBASE.signUpWithEmail, email, password);
        yield put({ type: successType, payload: { firebaseType, result } });
        break;
      }
      case FIREBASE.FIREBASE_TYPE.SIGNIN_FACEBOOK: {
        const result = yield call(FIREBASE.signInWithFacebookPreventFirstTime);
        yield put({ type: successType, payload: { firebaseType, result } });
        break;
      }
      case FIREBASE.FIREBASE_TYPE.SIGNIN_ANONYMOUS: {
        const result = yield call(FIREBASE.signInAnonymously);
        yield put({ type: successType, payload: { firebaseType, result } });
        break;
      }
      case FIREBASE.FIREBASE_TYPE.SIGNOUT: {
        const result = yield call(FIREBASE.signOut);
        yield put({ type: successType, payload: { firebaseType, result } });
        break;
      }
      // case FIREBASE.FIREBASE_TYPE.ADD_PERSONAL_INFORMATION: {
      //   const result = yield call(FIREBASE.addPersonalInformation);
      //   yield put({ type: successType, payload: { firebaseType, result } });
      //   break;
      // }
      case FIREBASE.FIREBASE_TYPE.GET_USER: {
        const result = yield call(FIREBASE.getUser);
        yield put({ type: successType, payload: { firebaseType, result } });
        break;
      }
      default:
        break;
    }
  } catch (error) {
    console.log(error);
    yield put({
      type: errorType,
      payload: { firebaseType, error: { code: error.code, message: error.message } },
    });
  }
}

export function* firebaseApi() {
  while (true) {
    const nextAction = yield take(FIREBASE_CALL);
    yield fork(handleFirebase, nextAction.payload);
  }
}

export default [firebaseApi()];
